// src/components/store/sections/newsletter/NewsletterV98BentosignupOceanCyan.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV98BentosignupOceanCyan(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={98}
      archKey="bento_signup"
      archLabel="Bento Multi-Tile Signup"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
